export default "__VITE_ASSET__Crg7raWd__"